import {
  FavSku,
  SearchedSku,
  SearchedSkuParams,
  UpdateFavSkusRequest,
  UserInfo,
  UserInfoUpdateRequest,
} from "@/features/my-account/types";
import axiosClient, { getAuthTokenFromCookies } from "@/utils/axios-client";
import { async } from "rxjs";

const url = {
  getUserInfo: (userId?: number) => `/users/${userId}`,
  getFavSkus: (buyer_id?: number) => `/buyers/${buyer_id}/favorite-skus`,
  getSearchedSkus: (buyer_id?: number) => `/buyers/${buyer_id}/search/sku`,

  updateUserInfo: (userId?: number) => `/users/${userId}`,
  updateFavSkus: (buyer_id?: number) => `/buyers/${buyer_id}/favorite-skus`,
};

export const myAccountApi = {
  getUserInfo: async (userId?: number): Promise<UserInfo> => {
    const { data } = await axiosClient.get<UserInfo>(url.getUserInfo(userId));
    return data;
  },
  getFavSkus: async (buyer_id?: number): Promise<FavSku> => {
    const { data } = await axiosClient.get<FavSku>(url.getFavSkus(buyer_id));
    return data;
  },
  getSearchedSkus: async (
    buyer_id?: number,
    params?: SearchedSkuParams
  ): Promise<SearchedSku> => {
    const { data } = await axiosClient.get<SearchedSku>(
      url.getSearchedSkus(buyer_id),
      { params }
    );
    return data;
  },

  updateUserInfo: async (data: UserInfoUpdateRequest, userId?: number) =>
    await axiosClient.put(url.updateUserInfo(userId), data, {
      headers: {
        Authorization: `Bearer ${getAuthTokenFromCookies()}`,
      },
    }),
  updateFavSkus: async (data: UpdateFavSkusRequest, buyer_id?: number) =>
    await axiosClient.put(url.updateFavSkus(buyer_id), data, {
      headers: {
        Authorization: `Bearer ${getAuthTokenFromCookies()}`,
      },
    }),
};
